import { useEffect, useState } from 'react';
import { Icon, IconButton } from '../design';
import { useClient } from '../lib/hooks';
import { offsetLabel } from '../work/calendar';

interface Shown {
  key: string;
  title: string;
  label: string;
  kind: 'event' | 'reminder';
}

/** Thông báo nhắc hẹn tự đóng sau chừng này ms (nhắc quan trọng nên để lâu hơn toast thường). */
const SHOW_MS = 30_000;

/**
 * Hiện nhắc hẹn / sự kiện lịch tới giờ (sự kiện realtime `reminder` từ máy chủ) ở mọi màn hình: thẻ nổi trong ứng
 * dụng, và thông báo trình duyệt khi tab đang ẩn và đã được cấp quyền.
 */
export function ReminderHost() {
  const client = useClient();
  const [shown, setShown] = useState<Shown[]>([]);

  useEffect(
    () =>
      client.on('reminder', (r) => {
        const item: Shown = { key: `${r.event_id}:${r.occurrence_start}:${r.offset}`, title: r.title, label: offsetLabel(r.offset), kind: r.kind };
        setShown((list) => [...list.filter((x) => x.key !== item.key), item].slice(-3));
        setTimeout(() => setShown((list) => list.filter((x) => x.key !== item.key)), SHOW_MS);
        if ('Notification' in window && Notification.permission === 'granted' && document.visibilityState === 'hidden') {
          try {
            new Notification(r.kind === 'reminder' ? 'Nhắc hẹn' : 'Sự kiện sắp diễn ra', { body: `${r.title} — ${item.label}`, tag: item.key });
          } catch {
            // Một số trình duyệt di động chỉ cho Notification qua service worker — thẻ nổi trong app vẫn hiện.
          }
        }
      }),
    [client],
  );

  if (!shown.length) return null;
  return (
    <div className="ws-reminders" role="region" aria-label="Nhắc hẹn" data-testid="reminders">
      {shown.map((s) => (
        <div key={s.key} className="ws-reminder" role="alert" data-testid="reminder-toast" data-kind={s.kind}>
          <span className="ws-reminder-icon ws-bell-ring" aria-hidden="true">
            <Icon name={s.kind === 'reminder' ? 'bell' : 'calendar'} size={18} />
          </span>
          <span className="ws-reminder-text">
            <b data-testid="reminder-title">{s.title}</b>
            <small data-testid="reminder-label">{s.label}</small>
          </span>
          <IconButton label="Đóng nhắc hẹn" icon="close" size={16} onClick={() => setShown((list) => list.filter((x) => x.key !== s.key))} />
        </div>
      ))}
    </div>
  );
}
